import { __ } from "@wordpress/i18n";
import apiFetch from '@wordpress/api-fetch';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import logout from "../assets/images/logout.svg";
import { useMenu } from '../contexts/MenuContext';
import { formatDateTime, formDataPost, timeAgo } from '../lib/Helpers';
import withForm from '../pages/withForm';
const LoginActionLogin = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    const [selectedRows, setSelectedRows] = useState([])
    const [bulkAction, setBulkAction] = useState("-1")
    const [userList,setUserList] = useState([])
    const [records, setRecords] = useState([])
    const [roleList,setRoleList] = useState([])
    const [activeRole, setActiveRole] = useState('')
    const [searchQuery,setSearchQuery] = useState('')
    const columns =  [
        { 
            id: 'username',
            name: __('Username', 'ultimate-security' ),
            cell: row => (
                <div className="d-flex flex-wrap align-items-center gap-2">
                    <img src={row.data.avatar} alt={row.data.display_name} width="40" height="40" />
                    <span><b>{row.data.user_login}</b></span>
                </div>
            ),

        },
        {
            id: 'email',
            name: __('Email', 'ultimate-security' ),
            selector: row => row.data.user_email,
            sortable: true,
        },
        { 
            id: 'role',
            name: __('Role', 'ultimate-security' ),
            selector: row => row.data.role,
            sortable: true,
        },
        { 
            id: 'login-activity',
            name: __('Login Activity', 'ultimate-security' ),
            cell: row => (
                <div className="login-activity-wrap">
                    <div className="login-details">
                        <span className="time-ago">{timeAgo(row.data.plulsc_user_last_logged_in)}</span>                
                        <img title={__( "Logout", 'ultimate-security' )} src={logout} role="button" onClick={() => handleClickForceLogout(row.ID)}/>
                    </div>
                    <span className="formated-time">{formatDateTime(row.data.plulsc_user_last_logged_in)}</span> 
                </div>
            ),
            ignoreRowClick: true, // Prevent triggering row click event
            allowoverflow: true, // Ensure it doesn’t interfere with other UI
            button: true, // Ensures proper styling for buttons
            minwidth: "250px",
            style: {display: 'flex', justifyContent: 'end', paddingRight: '11px'}
        }
    ]

    useEffect(() => {
        const baseURL = '/ultimate-security/v1';        
        const getRoleData = async () => {
            try {
                const response = await apiFetch({
                    path: `${baseURL}/get-roles`,
                    method: 'GET'
                });
        
                const rolesArray = Object.entries(response).map(([key, value]) => ({
                    role: key,
                    ...value
                }));
        
                setRoleList(rolesArray);
        
            } catch (error) {
                console.log(error);
            }
        };
        getRoleData();
    },[])
    
    useEffect(() => {
        const baseURL = '/ultimate-security/v1';        
        const getUserData = async () => {
            try {
                const response = await apiFetch({
                    path: `${baseURL}/get-users`,
                    method: 'GET'
                });
        
                setUserList(response);
                setRecords(response);
        
            } catch (error) {
                console.log(error);
            }
        };
        getUserData();
    },[])

    const handleSelectedRowsChange = ({ selectedRows }) => {
        setSelectedRows(selectedRows);
    };
    const handleUserSearch = (e) => {
        setSearchQuery(e.target.value)
        setActiveRole('') // Reset the active role
        const newData = userList.filter(row => {
            return row.data.user_login.toLowerCase().includes(e.target.value.toLowerCase())
        })
        setRecords(newData)
    }
    const handleUserFilter = (role) => {
        setSearchQuery('')
        if (role == 'All') {
            setRecords(userList)        
            setActiveRole(''); // Set the active role
        } else {
            const newData = userList.filter(row => {
                return row.data.role.toLowerCase().includes(role.toLowerCase())
            })
            setRecords(newData)        
            setActiveRole(role); // Set the active role
        }
    }
    

    const handleBulkActionChange = (e) => {
        setBulkAction(e.target.value);
    };    
    const handleBulkActionSubmit = () => {
        if (selectedRows.length) {
            const ids = selectedRows.map(item => item.ID);
            if (bulkAction === "delete") {
                console.log("Delete these ids", ids)
                
            } else {
                alert("Please select a valid action.");
            }
        } else {
            alert("Please select users.");
        }
    };

    const handleClickForceLogout = async (userId) => {
        const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
        if (confirmed) {      
            try {
                const result = await formDataPost('plulsc_user_force_logout', {user_id: userId}); 
                console.log('result', result);
                if (result.success) {
                    window.alert(__('Logged Out', 'ultimate-security'))
                }
            } catch (error) {
                console.log(error);
            } finally {
            }
        }       
    };
    return (
        <>
            <div className="setting-unit">
                <div className="user-datatable datatable-unit">
                    <div className="row justify-content-between mb-30">
                        <div className="col-8 filters">
                            <div className="d-flex flex-wrap wp-roles">
                                <span
                                    onClick={() => handleUserFilter('All')}
                                    className={activeRole === '' ? 'active' : ''} // Apply active class conditionally
                                    >All</span>
                                {
                                    roleList && roleList.map(item=> (                                        
                                        item?.count ? 
                                        <span 
                                            key={item.role} 
                                            value={item.role} 
                                            onClick={() => handleUserFilter(item.name)}
                                            className={activeRole === item.name ? 'active' : ''} // Apply active class conditionally
                                        >
                                        {item.name} ({item.count})
                                        </span> 
                                        : ''                                        
                                    ))      
                                }
                            </div>
                            <div className="bulk-action-wrapper">
                                <select value={bulkAction} name="action"  onChange={handleBulkActionChange}>
                                    <option value="-1">{__( 'Bulk actions', 'ultimate-security' )}</option>
                                    <option value="reset">{__( 'Reset', 'ultimate-security' )}</option>
                                    <option value="delete">{__( 'Delete', 'ultimate-security' )}</option>
                                </select>
                                <button className="button button-secondary" onClick={handleBulkActionSubmit}>Apply</button>
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="search-unit d-flex gap-2 align-items-center">
                                <input placeholder="Search Users" type="search" onChange={handleUserSearch} value={searchQuery} />
                                <button className="button button-secondary" type="button">{__( 'Search', 'ultimate-security' )}</button>
                            </div>
                        </div>
                    </div>            
                    <div className="table-wrapper">
                        <DataTable
                            columns={columns}
                            data={records}
                            selectableRows // for making row selectable
                            onSelectedRowsChange={handleSelectedRowsChange} // Handle row selection changes  
                          
                            pagination
                            dense
                            responsive
                        />
                    </div> 
                </div> 
            </div>
        </>
    )
}
export default withForm(LoginActionLogin);